import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Button,
    Checkbox,
    Paper,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow,
    Typography
} from "@material-ui/core";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import {
    FilterContentStyled, FooterContentStyled,
    FormContentMainStyled,
    FormContentSizeButtonMainStyled, FormContentSizeTableMainStyled,
    PushStatusBadgeStyled
} from "../styled";
import CheckBoxDefaultComponent
    from "../../../../Components/CheckBoxDefaultComponent/CheckBoxDefaultComponent";
import TextFieldDefault
    from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import DateUtil from "../../../../Utils/DateUtil";
import PaginationComponent
    from "../../../../Components/PaginationComponent/PaginationComponent";

class TableCreateFormMensageriaComponente extends Component {

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            erros: [],
            search: '',
        };

    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({[name]: value});
    }

    render() {
        const { clients, selectedClients, sendToAll, pagination } = this.props;
        const allCurrentPageSelected = clients && clients.length > 0 && clients.every(c => selectedClients?.includes(c.uuid));

        return (
            <FormContentMainStyled>
                <FormContentSizeTableMainStyled>
                    <SpacerComponent height={40}/>
                    <Typography align={'left'}
                                variant={'h6'}
                                color={'primary'}>
                        Filtros
                    </Typography>
                    <CheckBoxDefaultComponent
                        onChange={(event) => this.props.onToggleSendToAll && this.props.onToggleSendToAll(event)}
                        checked={sendToAll}
                        label={'Enviar para todos os clientes'}/>

                    <FilterContentStyled>
                        <TextFieldDefault label={'Busque por nome ou CPF *'}
                                          name={'search'}
                                          type={'text'}
                                          value={this.state.search}
                                          onChange={(event) => this.handleChange(event)}
                                          erros={this.props.erros}
                                          width={'300px'}
                        />
                        <SpacerComponent width={20}/>
                        <Button variant={'contained'}
                                color={'primary'}
                                size={"large"}
                                fullWidth={false}
                                onClick={() => {
                                    if (this.props.onChangePage) {
                                        this.props.onChangePage(1, this.state.search || '');
                                    }
                                }}>
                            Filtrar
                        </Button>
                    </FilterContentStyled>
                    <SpacerComponent height={20}/>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox color="primary"
                                                  disabled={sendToAll}
                                                  checked={sendToAll || Boolean(allCurrentPageSelected)}
                                                  onChange={() => this.props.onSelectAllCurrentPage && this.props.onSelectAllCurrentPage(clients)}
                                        />
                                    </TableCell>
                                    <TableCell>Nome</TableCell>
                                    <TableCell>CPF</TableCell>
                                    <TableCell>Push</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {clients && clients.length > 0 ? (
                                    clients.map((client, index) => {
                                        const isPushActive = client.push === 'on' || client.push === true;
                                        const isChecked = sendToAll || (selectedClients && selectedClients.includes(client.uuid));
                                        return (
                                            <TableRow key={client.uuid || index}>
                                                <TableCell padding="checkbox">
                                                    <Checkbox color="primary"
                                                              disabled={sendToAll}
                                                              checked={Boolean(isChecked)}
                                                              onChange={() => this.props.onSelectClient && this.props.onSelectClient(client.uuid)}
                                                    />
                                                </TableCell>
                                                <TableCell>{client.name}</TableCell>
                                                <TableCell>{client.cpf}</TableCell>
                                                <TableCell>
                                                    <PushStatusBadgeStyled active={isPushActive}>
                                                        {isPushActive ? 'Ativo' : 'Desativado'}
                                                    </PushStatusBadgeStyled>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            Nenhum cliente encontrado
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <SpacerComponent height={16}/>
                    {pagination && (
                        <PaginationComponent
                            total={parseInt(pagination?.total || 0)}
                            perPage={parseInt(pagination?.per_page || 15)}
                            currentPage={parseInt(pagination?.current_page || 1)}
                            lastPage={parseInt(pagination?.last_page || 1)}
                            itensVisible={2}
                            onChangePage={(page) => {
                                if (this.props.onChangePage) {
                                    this.props.onChangePage(page, this.state.search || '');
                                }
                            }}
                        />
                    )}
                    <SpacerComponent height={16}/>
                    <FooterContentStyled>
                        <Typography align={'left'}
                                    variant={'subtitle1'}>
                            {sendToAll
                                ? `${pagination?.total || 0} destinatários selecionados (Todos)`
                                : `${selectedClients?.length || 0} destinatários selecionados`}
                        </Typography>
                        <Typography align={'right'}
                                    variant={'subtitle1'}>
                            Envios este mês: {pagination?.quota?.sent_in_period ?? 0}/{pagination?.quota?.limit ?? 0}
                        </Typography>
                    </FooterContentStyled>
                    <SpacerComponent height={32}/>
                </FormContentSizeTableMainStyled>
            </FormContentMainStyled>
        );
    }
}

TableCreateFormMensageriaComponente.defaultProps = {
    clients: [],
    selectedClients: [],
    sendToAll: false,
    pagination: null,
    onChangePage: () => {},
    onSelectClient: () => {},
    onSelectAllCurrentPage: () => {},
    onToggleSendToAll: () => {},
};

TableCreateFormMensageriaComponente.propTypes = {
    clients: PropTypes.array,
    selectedClients: PropTypes.array,
    sendToAll: PropTypes.bool,
    pagination: PropTypes.object,
    onChangePage: PropTypes.func,
    onSelectClient: PropTypes.func,
    onSelectAllCurrentPage: PropTypes.func,
    onToggleSendToAll: PropTypes.func,
};

export default TableCreateFormMensageriaComponente;